// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useDisclosure } from '@/hooks/use-disclosure';
import { Tooltip, Typography, TypographyProps } from '@mui/material';
import { MouseEventHandler, PropsWithChildren } from 'react';

/**
 * A Typography component that displays a tooltip on hover if the text
 * content overflows the element.
 */
export function OverflowTypography(props: PropsWithChildren<TypographyProps>) {
  const tooltip = useDisclosure();

  const handleMouseEnter: MouseEventHandler<HTMLElement> = (event) => {
    if (event.currentTarget.scrollWidth > event.currentTarget.clientWidth) {
      tooltip.open();
    }

    if (props.onMouseEnter) {
      props.onMouseEnter(event);
    }
  };

  const handleMouseLeave: MouseEventHandler<HTMLElement> = (event) => {
    tooltip.close();

    if (props.onMouseLeave) {
      props.onMouseLeave(event);
    }
  };

  return (
    <Tooltip arrow placement="top" title={props.children} open={tooltip.isOpen}>
      <Typography
        {...props}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {props.children}
      </Typography>
    </Tooltip>
  );
}
